//#region Imports
import React from "react";
import { Stack, Typography, AppBar, Toolbar } from "@mui/material";

// Components
import ControlButtons from "./Control Buttons";
import { Navigation } from "./Navigation";
//#endregion

/**
 * Creates desktop header element
 * @param {Object} props Props of the element
 * @param {Number} props.xPaddings Paddings on the X axis
 * @returns {JSX.Element} An element of the desktop header
 */
const DesktopHeader = ({ xPaddings }) => {
  return (
    <AppBar
      component="header"
      position="static"
      sx={{ py: 2, px: xPaddings }}
      elevation={0}>
      <Toolbar
        sx={{
          flexDirection: "row",
          gap: 4,
          alignItems: "center",
        }}>
        <Typography
          variant="headlineSmall"
          component="h1"
          sx={{ width: "14.8rem", textAlign: "left" }}>
          Intelligent Automation Team
        </Typography>
        <Navigation />
        <ControlButtons />
      </Toolbar>
    </AppBar>
  );
};

export default DesktopHeader;
